import styled from "styled-components";
import BankingWrapper from "../../layout/BankingWrapper";
import BusinessAccount from "../../components/user/business-banking/home/BusinessAccount";
import StoreAccount from "../../components/user/business-banking/home/StoreAccount";
import { graph } from "../../assets";
import DebitCard from "../../components/user/business-banking/DebitCard";


const BusinessBanking = () => {
      return (
            <BankingWrapper
                  title={'Business Banking'}
            >
                  <StyledBizBanking>
                        <div className="row">
                              <div className="col-lg-6 mb-3">
                                    <BusinessAccount />
                              </div>
                              <div className="col-lg-6 mb-3">
                                    <StoreAccount />
                              </div>
                        </div>
                        <div className="row">
                              <div className="col-lg-7 mb-3">
                                    <img src={graph} alt="graph" width="100%"
                                    />
                              </div>
                              <div className="col-lg-5 mb-3">
                                    <DebitCard />
                              </div>
                        </div>

                  </StyledBizBanking>

            </BankingWrapper>

      );
};

export default BusinessBanking;

const StyledBizBanking = styled.section`


`;